import { useEffect, useState } from 'react'
import { useCookie, useEffectOnce } from 'react-use'
import cookieKeys from '../database/cookie-keys'
import { IUserPreferences } from '../@types'

export function useLessonViewMode() {
  const [cookies, setCookies] = useCookie(cookieKeys.preferences)
  const [isListView, setListViewMode] = useState<boolean>(false)

  const toggle = () => {
    setListViewMode(!isListView)
  }

  useEffectOnce(() => {
    if (cookies) {
      const { lessonListViewMode } = JSON.parse(cookies) as IUserPreferences
      setListViewMode(lessonListViewMode)
    }
  })

  useEffect(() => {
    if (cookies) {
      const preferences = JSON.parse(cookies) as IUserPreferences
      setCookies(
        JSON.stringify({ ...preferences, lessonListViewMode: isListView }),
      )
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cookies, isListView])

  return { toggle, isListView }
}
